import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ToastrModule } from 'ngx-toastr';
import { HttpClientModule } from '@angular/common/http';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxPaginationModule } from 'ngx-pagination';
import { AngularMaterialModule } from '../angular-material.module';
import { SortByPipe } from '../sort-byPipe';
import { SpecialPipe } from '../specialPipe';
import { ManageConsolePipe } from '../manage-console-pipe';
import { FilterDataPipe } from '../test/test-step/filterDataPipe';
import { StringSearchPipe } from '../string-search.pipe';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { CustomDatePipe } from '../pipes/custom-date.pipe';
import { DueTimePipe } from '../pipes/due-time.pipe';


@NgModule({
  declarations: [
     
    SpecialPipe,
    SortByPipe ,
    ManageConsolePipe,
    FilterDataPipe,
    StringSearchPipe,
    CustomDatePipe,
    DueTimePipe
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule.forRoot(),
    NgMultiSelectDropDownModule.forRoot(),
    // HttpClientModule,
    DragDropModule,

    NgxPaginationModule,
    // FileSaverModule,
    // BrowserModule,
  
    // BrowserAnimationsModule,
  ],
  exports: [ CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ToastrModule,
    // HttpClientModule,
    DragDropModule,
    NgxPaginationModule,
    // FileSaverModule,
    // BrowserModule,
  
    // BrowserAnimationsModule,
    SpecialPipe,
    SortByPipe,
    FilterDataPipe,
    StringSearchPipe,
    NgMultiSelectDropDownModule,
    ManageConsolePipe, 
    CustomDatePipe,
    DueTimePipe ]
})
export class SharedModule { }
